module.exports = __webpack_public_path__ + "static/media/searchmobile.cb537a25.svg";